import React from 'react';
import { store } from '../../store'
import TilbodNavigation from '../tilbod-navigation'
import Tab from 'react-bootstrap/Tab'
import Nav from 'react-bootstrap/Nav'
import { customerNameById, customerByKennitala, formatKennitala, allHealthQuestionGroupsChecked, hasAnyQuestions } from '../../utils'
import { fetchAllHealthQuestions } from '../../api/health-questions/actions'
import HealthQuestions from '../health-questions'
import connectWithStore from '../../utils/store'
import VIDTmodule from '../vid-t-module'

import { SvgCheckIcon } from '../svg';

import { getFundTable } from '../../api/fund-table/actions'


class TilbodStepHealthQuestions extends React.Component {

    constructor(props) {
        super(props)
    }

    componentDidMount() {

        const { offers } = this.props
        if (offers && Object.keys(offers.offerQueryParameters).length > 0) {
            let fetchString = []
            for (var kennitala of Object.keys(offers.offerQueryParameters)) {
                for (var offerType of Object.keys(offers.offerQueryParameters[kennitala])) {
                    if (offers.offerQueryParameters[kennitala][offerType] === true) {
                        let _offerType = offerType
                        if (["FOR", "REN"].includes(offerType) && this.props.infoCollection.data[kennitala]["RENdeathbenefits"] === true) {
                            _offerType = `${offerType}D`
                        }
                        fetchString.push(_offerType)
                        
                        if(["VIDT","VID"].includes(offerType)){
                            this.props.dispatch(getFundTable())
                        }
                    }
                }
            }
            this.props.dispatch(fetchAllHealthQuestions(fetchString.join(","), fetchString.join(",")))
        }
    }

    // getInitialValues(customerId) {
    //     console.log(this.props.infoCollection.data.find(f => f.customerId === customerId))
    //     return this.props.infoCollection.data.find(f => f.customerId === customerId)
    // }

    // componentWillMount() {
    //     Object.keys(this.props.offers.offerQueryParameters).map((customerId, idx) => {
    //         this.props.dispatch(setInfoKey({ key: undefined, value: undefined }, customerId))
    //     })
    // }

    onNavLinkClick(e) {
        var tab = $(e.target).parents('.nav-item').prev('.nav-item');

        $('.tabs .nav-item').removeClass('no-border');
        tab.addClass('no-border');
    }

    // onButtonClick(e) {
    //     $('.step-2 .card-header').removeClass('body-show');
    //     if(!$(e.target).parent().siblings('.collapse').hasClass('show')) {
    //         $(e.target).parent().addClass('body-show');
    //     }
    // }

    render() {
        let customers = this.props.customers;

        return (
            <>
                <div className="row justify-content-center xs-pt-10">
                    <div className="col-12 col-sm-10 col-md-8">
                        <div className="row justify-content-center xs-pt-10 step">

                            <Tab.Container defaultActiveKey={Object.keys(this.props.offers.offerQueryParameters)[0]} >
                                <div className="tabs-container">
                                    <Nav variant="tabs" className="tabs">
                                        {Object.keys(this.props.offers.offerQueryParameters).map((customerId, idx) =>
                                            <Nav.Item key={customerId} className="check">
                                                <Nav.Link eventKey={customerId} onClick={this.onNavLinkClick.bind(this)}>
                                                    {customerNameById(customerId, this.props.customers)}<span>({formatKennitala(customerId)})</span>
                                                </Nav.Link>
                                                {allHealthQuestionGroupsChecked(customerId, this.props.offers, this.props.infoCollection, this.props.healthQuestions) &&
                                                    <span className="check-icon small blue"><SvgCheckIcon /></span>
                                                }

                                            </Nav.Item>
                                        )}
                                    </Nav>
                                </div>


                                <Tab.Content className="w-100">
                                    {Object.keys(this.props.offers.offerQueryParameters).map((customerId, idx) =>
                                        <Tab.Pane key={customerId} eventKey={customerId}>
                                            {Object.keys(this.props.offers.offerQueryParameters[customerId]).filter((off) => this.props.offers.offerQueryParameters[customerId][off] === true).map((productCode, idx) => {
                                                if (hasAnyQuestions(customerId, this.props) || ['VID', 'VIDT'].includes(productCode)) {
                                                    if (['FOR', 'REN'].includes(productCode)) {
                                                        let _offerType = productCode
                                                        if(this.props.infoCollection.data[customerId]['RENdeathbenefits'] === true){
                                                            _offerType = `${_offerType}D`
                                                        }
                                                        if (this.props.healthQuestions.results[_offerType]) {
                                                            return (
                                                            <HealthQuestions 
                                                                key={`${customerId}-${_offerType}`}
                                                                title={`Viðbótarupplýsingar vegna ${productCode}`}
                                                                offerType={_offerType}
                                                                healthQuestions={this.props.healthQuestions}
                                                                customer={customerByKennitala(customerId, customers)}
                                                                customerId={customerId} dispatch={this.props.dispatch}
                                                                infoCollection={this.props.infoCollection.data[customerId]}
                                                                totalInfoCollection={this.props.infoCollection}
                                                                offerQueryParams={this.props.offers.offerQueryParameters[customerId]}
                                                                showStopper={this.props.gui.showStopper}
                                                                showStopperType={this.props.gui.showStopperType[customerId] || 'default'}
                                                                offers={this.props.offers}
                                                                allInfoCollection={this.props.infoCollection}
                                                                allQueryParams={this.props.offers.offerQueryParameters} 
                                                            />)
                                                        } else {
                                                            return null
                                                        }
                                                    } else if (['VID'].includes(productCode)) {
                                                        let VIDmodules = [];
                                                        if (this.props.healthQuestions.results[productCode]) {
                                                            VIDmodules.push(
                                                            <HealthQuestions
                                                                key={`${customerId}-${productCode}-hq`}
                                                                title={`Viðbótarupplýsingar vegna ${productCode}`}
                                                                offerType={productCode}
                                                                healthQuestions={this.props.healthQuestions}
                                                                customer={customerByKennitala(customerId, customers)}
                                                                customerId={customerId}
                                                                dispatch={this.props.dispatch}
                                                                infoCollection={this.props.infoCollection.data[customerId]}
                                                                totalInfoCollection={this.props.infoCollection}
                                                                offerQueryParams={this.props.offers.offerQueryParameters[customerId]}
                                                                showStopper={this.props.gui.showStopper}
                                                                showStopperType={this.props.gui.showStopperType[customerId] || 'default'}
                                                                offers={this.props.offers} allInfoCollection={this.props.infoCollection}
                                                                allQueryParams={this.props.offers.offerQueryParameters} 
                                                            />)
                                                        }
                                                        // VIDmodules.push(<VIDmodule customerId={customerId} dispatch={this.props.dispatch} offerQueryParams={this.props.offers.offerQueryParameters[customerId]} />)
                                                        VIDmodules.push(<VIDTmodule key={`${customerId}-${productCode}-module`} type={"VID"} customerId={customerId} dispatch={this.props.dispatch} offerQueryParams={this.props.offers.offerQueryParameters[customerId]} title="Ævilífeyrir - Prósentuskipting og/eða uppsögn" />)
                                                        return VIDmodules;
                                                    } else if (['VIDT'].includes(productCode)) {
                                                        let VIDTmodules = [];
                                                        if (this.props.healthQuestions.results[productCode]) {
                                                            VIDTmodules.push(
                                                            <HealthQuestions
                                                                key={`${customerId}-${productCode}-hq`}
                                                                title={`Ævilífeyrir (tilgreind séreign) ${productCode} - Viðbótarupplýsingar`}
                                                                offerType={productCode}
                                                                healthQuestions={this.props.healthQuestions}
                                                                customer={customerByKennitala(customerId, customers)}
                                                                customerId={customerId} dispatch={this.props.dispatch}
                                                                infoCollection={this.props.infoCollection.data[customerId]}
                                                                totalInfoCollection={this.props.infoCollection}
                                                                offerQueryParams={this.props.offers.offerQueryParameters[customerId]}
                                                                showStopper={this.props.gui.showStopper}
                                                                showStopperType={this.props.gui.showStopperType[customerId] || 'default'}
                                                                offers={this.props.offers}
                                                                allInfoCollection={this.props.infoCollection}
                                                                allQueryParams={this.props.offers.offerQueryParameters}
                                                                fundTable={this.props.fundTable}
                                                            />)
                                                        }
                                                        // VIDTmodules.push(<VIDTmodule customerId={customerId} dispatch={this.props.dispatch} offerQueryParams={this.props.offers.offerQueryParameters[customerId]} />)
                                                        VIDTmodules.push(<VIDTmodule key={`${customerId}-${productCode}-module`} type={"VIDT"} customerId={customerId} dispatch={this.props.dispatch} offerQueryParams={this.props.offers.offerQueryParameters[customerId]} title="Ævilífeyrir (tilgreind séreign) - uppsögn"/>)
                                                        return VIDTmodules;
                                                    } else if (!['FOR', 'REN'].includes(productCode)){
                                                        if (this.props.healthQuestions.results[productCode]) {
                                                            return (
                                                            <HealthQuestions
                                                                key={`${customerId}-${productCode}`}
                                                                title={`Viðbótarupplýsingar vegna ${productCode}`}
                                                                offerType={productCode}
                                                                healthQuestions={this.props.healthQuestions}
                                                                customer={customerByKennitala(customerId, customers)}
                                                                customerId={customerId} dispatch={this.props.dispatch}
                                                                infoCollection={this.props.infoCollection.data[customerId]}
                                                                totalInfoCollection={this.props.infoCollection}
                                                                offerQueryParams={this.props.offers.offerQueryParameters[customerId]}
                                                                showStopper={this.props.gui.showStopper}
                                                                showStopperType={this.props.gui.showStopperType[customerId] || 'default'}
                                                                offers={this.props.offers}
                                                                allInfoCollection={this.props.infoCollection}
                                                                allQueryParams={this.props.offers.offerQueryParameters} 
                                                            />)
                                                        } else {
                                                            return null
                                                        }
                                                    } 
                                                }
                                                else {
                                                    return (<div key={`${customerId}-${productCode}-none`}>Ekki er þörf á að skrá inn viðbótarupplýsingar fyrir {customerNameById(customerId, this.props.customers)} ({formatKennitala(customerId)})</div>)
                                                }
                                            })}
                                        </Tab.Pane>
                                    )}
                                </Tab.Content>
                            </Tab.Container>
                        </div>
                    </div>
                </div>

                <TilbodNavigation />
            </>
        )
    }
}

TilbodStepHealthQuestions.defaultProps = {
}

function mapStateToProps(state) {

    var f = {
        customers: {},
        offers: {},
        gui: {},
        nationalRegistry: {},
        infoCollection: {},
        virtualCard: {},
        fundTable: {},
        healthQuestions: {},
    }
    f.customers = (state.customers === undefined) ? {} : state.customers
    f.offers = (state.offers === undefined) ? {} : state.offers
    f.gui = (state.gui === undefined) ? {} : state.gui
    f.nationalRegistry = (state.nationalRegistry === undefined) ? {} : state.nationalRegistry
    f.infoCollection = (state.infoCollection === undefined) ? {} : state.infoCollection
    f.virtualCard = (state.virtualCard === undefined) ? {} : state.virtualCard
    f.fundTable = (state.fundTable === undefined) ? {} : state.fundTable
    f.healthQuestions = (state.healthQuestions === undefined) ? {} : state.healthQuestions

    return f;
}

export default connectWithStore(store, TilbodStepHealthQuestions, mapStateToProps);
